import styled from 'styled-components'
import { colors } from '../../../../constants'
import type { Playlist } from '../../../../types'

const MainPlaylistName = styled.span`
    font-weight: 600;
`

const MainPlaylistNameDefault = styled(MainPlaylistName)`
    color: ${colors.bluedark};
`

const MainPlaylistNameSelected = styled(MainPlaylistName)`
    color: ${colors.white};
`

interface PlaylistNameProps {
    children: Playlist;
    selectedId: number;
}

export default function PlaylistName({ children, selectedId }: PlaylistNameProps) {
    const { id, name, slug } = children

        if (slug === 'MAIN') {
            if (selectedId === id) {
                return <MainPlaylistNameSelected>{name}</MainPlaylistNameSelected>
            }

            return <MainPlaylistNameDefault>{name}</MainPlaylistNameDefault>
        }

        return name
}
